"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineSpectrumAnalyzer = exports.SpectrumAnalyzer = void 0;
const lib_es2015_1 = require("@hodol/web-component-helper/lib-es2015");
const apis_1 = require("./apis");
const lib_es2015_2 = require("@hodol/dom-helper/lib-es2015");
const spectrum_ranking_1 = require("./spectrum-ranking");
const numbers = Array.from({ length: 45 }, (_, i) => i + 1);
class SpectrumAnalyzer extends HTMLElement {
    constructor() {
        super();
        this.spectrumApis = new apis_1.default();
        this.style.setProperty('display', 'grid');
        this.style.setProperty('grid-template-row', '1fr 1fr');
        this.innerHTML = `
      <div style="box-sizing: border-box; padding: 0.5rem; position: sticky; top: 0; left: 0; background-color: white; width: 100%; box-shadow: 0 -5px 15px 0 black; font-size: x-large;">
        <button class="prev-number" style="font-size: inherit;">&#9660;</button>
        <select style="font-size: inherit;">
          <option value="0">Number</option>
        </select>
        <button class="next-number" style="font-size: inherit;">&#9650;</button>
        <span class="number-spectra" style="margin: 0 0.2rem;"></span>
      </div>`;
        this.numberSpectrumDegree3 = (0, lib_es2015_2.getQuerySelectOrThrowError)(this, 'span.number-spectra');
        this.numberSelect = (0, lib_es2015_2.getQuerySelectOrThrowError)(this, 'select');
        (0, lib_es2015_2.getQuerySelectOrThrowError)(this, 'button.prev-number').addEventListener('click', () => {
            const selectedOption = this.numberSelect.selectedOptions[0];
            const prevOption = selectedOption.previousElementSibling;
            if (prevOption === null)
                return;
            if (prevOption.value === '0')
                return;
            prevOption.selected = true;
            this.numberSelect.dispatchEvent(new Event('change'));
        });
        (0, lib_es2015_2.getQuerySelectOrThrowError)(this, 'button.next-number').addEventListener('click', () => {
            const selectedOption = this.numberSelect.selectedOptions[0];
            const nextOption = selectedOption.nextElementSibling;
            if (nextOption === null)
                return;
            nextOption.selected = true;
            this.numberSelect.dispatchEvent(new Event('change'));
        });
    }
    connectedCallback() {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.spectrumApis.getHypotheticalSpectra(3);
            if (resp === null) {
                alert(`fail to get hypothetical spectra`);
                return;
            }
            numbers.forEach(n => {
                const numberOpt = (0, lib_es2015_2.buildNodeByOuterHTML)(`<option value="${n}">${n}</option>`);
                const spectrumRankingContainer = (0, lib_es2015_2.buildNodeByOuterHTML)(`<div class="spectrum-ranking number-${n}" style="display: none; grid-template-columns: auto auto auto; align-items: start;"></div>`);
                this.numberSelect.appendChild(numberOpt);
                this.appendChild(spectrumRankingContainer);
            });
            this.numberSelect.addEventListener('change', () => {
                const n = this.numberSelect.value;
                const spectrumRankingContainer = (0, lib_es2015_2.getQuerySelectOrThrowError)(this, `div.spectrum-ranking.number-${n}`);
                this.numberSpectrumDegree3.innerHTML = `${resp[`${n}`][resp[`${n}`].length - 1]}`;
                Array.from(this.children).filter(item => item.classList.contains(`spectrum-ranking`)).forEach(item => item.style.setProperty('display', 'none'));
                spectrumRankingContainer.innerHTML = resp[`${n}`].map(spectrum => `<spectrum-ranking number="${n}" window-size="${spectrum.split('-').length}" hypothetical-spectrum="${spectrum}"></spectrum-ranking>`).join(' ');
                spectrumRankingContainer.style.setProperty('display', 'grid');
            });
        });
    }
}
exports.SpectrumAnalyzer = SpectrumAnalyzer;
const defineSpectrumAnalyzer = (name) => {
    (0, lib_es2015_1.defineIfUndefined)(name, SpectrumAnalyzer);
    (0, spectrum_ranking_1.defineSpectrumRanking)('spectrum-ranking');
};
exports.defineSpectrumAnalyzer = defineSpectrumAnalyzer;
